var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:'s-icon ' + _vm.size,attrs:{"src":require('@/assets/icons/' + _vm.iconName + '.svg')}})}
var staticRenderFns = []

export { render, staticRenderFns }